import axios from 'axios';
import { API_CORE_URL } from '../constantes/constantes';

/**
 * Obtiene los datos para el carrusel desde un endpoint específico.
 *
 * @param {Object} params
 * @param {string} params.endpoint - URL completa del JSON a consumir.
 * @returns {Promise<{ data: any, statusCode: number }>}
 */
export async function getCarrousel({ endpoint, version: country }) {
  try {
    const { data, status } = await axios.get(endpoint, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
      params: {
        ...(country === 'us' && {country})
      },
    });

    return { statusCode: status, data };
  } catch (error) {
    console.error('Error en la petición:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: [] };
  }
}

/**
 * Obtiene el listado del menu de ligas
 *
 * @param {Object} params
 * @param {string} params.version - Versión del endpoint ('us' o por defecto)
 * @returns {Promise<{ data: any, statusCode: number }>}
 */
export async function getFilters({ version }) {
  const endpoint = `${API_CORE_URL}league-menu`;

  return await getCarrousel({ endpoint, version });
}